export default __webpack_public_path__ + "922f7904a9b6e4c1851778e33b1c32e9.svg";